import * as toastr from 'toastr';
import {DeviceService} from "./DeviceService";

export interface INavigator {
  notification: INotifiaction;
}

export interface INotifiaction {
  alert(message: string, clb: () => void, title?: string, buttonName?: string): void;

  prompt(message: string, clb: (res: IDialogueResult) => void, title?: string, buttonLables?: string[], defaultText?: string): void;

  confirm(message: string, clb: (res: number) => void, title?: string, buttonLabels?: string[]): void;
}

export interface IDialogueResult {
  buttonIndex: number;
  input1: string;
}

export class NotificationService {

  static $inject = ["$q", DeviceService.serviceId];
  static serviceId = "notification";

  nav: INavigator;

  constructor(private $q: ng.IQService, private device: DeviceService) {
    this.nav = <any>navigator;
    this.initToastr();
  }

  error(msg: string, title?: string) {
    toastr.error(msg, title);
  }

  confirm(message: string, title?: string, button1Name?: string, button2Name?: string) {
    const d = this.$q.defer<string>();
    const clb = (buttonIndex: number) => {
      if (buttonIndex == 1) {
        d.resolve();
      } else {
        d.reject();
      }
    };
    this.nav.notification.confirm(message, clb, title, this.getNames(button1Name, button2Name));
    return d.promise;
  }

  toastInfo(message, title?) {
    toastr.info(message, title);
  }

  toastWarning(message, title?) {
    toastr.warning(message, title);
  }

  toastError(message, title?) {
    toastr.error(message, title);
  }

  toastSuccess(message, title?) {
    toastr.success(message, title);
  }

  info(msg: string, title?: string) {
    toastr.info(msg, title);
  }

  private getNames(name1: string, name2: string) {
    name1 = name1 || "Ok";
    name2 = name2 || "Cancel";
    return [name1, name2];
  }

  private initToastr = () => {
    toastr.options.timeOut = 5000;
    toastr.options.positionClass = this.device.isTablet() ? "toast-bottom-full-width" : "toast-bottom-full-width";
    toastr.options.showMethod = "fadeIn";
    toastr.options.hideMethod = "fadeOut";
  }
}